import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 



const ChangeList = lazy(() => import("../pages/changecontrol/ChangeList"));
const ChangeAdd = lazy(() => import("../pages/changecontrol/ChangeAdd"));
const ChangeEdit = lazy(() => import("../pages/changecontrol/ChangeEdit"));

const ImpactAssessmentList = lazy(() => import("../pages/changecontrol/ImpactAssessmentList"));
const AddImpactAssessment = lazy(() => import("../pages/changecontrol/wizard/index"));
const EditImpactAssessment = lazy(() => import("../pages/changecontrol/ImpactAssessmentEdit"));

const Documents = lazy(() => import("../pages/changecontrol/Documents"));
const Content = lazy(() => import("../pages/changecontrol/Content"));
const Reports = lazy(() => import("../pages/changecontrol/Reports"));

const DevicesList = lazy(() => import("../pages/devices/DevicesList"));
const DevicesAdd = lazy(() => import("../pages/devices/DevicesAdd"));
const OtherNames = lazy(() => import("../pages/devices/OtherNames"));
const DevicesEdit = lazy(() => import("../pages/devices/DevicesEdit"));
const AddOtherName = lazy(() => import("../pages/devices/AddOtherName"));
const Components = lazy(() => import("../pages/devices/Components"));
const AddComponents = lazy(() => import("../pages/devices/AddComponents"));
const Models = lazy(() => import("../pages/devices/Models"));
const AddModel = lazy(() => import("../pages/devices/AddModel"));
const Specifications = lazy(() => import("../pages/devices/Specifications"));
const AddSpecifications = lazy(() => import("../pages/devices/AddSpecifications"));
const ApplicableStandards = lazy(() => import("../pages/devices/ApplicableStandards"));
const AddApplicableStandard = lazy(() => import("../pages/devices/AddApplicableStandard"));
const Packages = lazy(() => import("../pages/devices/Packages"));
const AddPackage = lazy(() => import("../pages/devices/AddPackage"));
const DocumentsList = lazy(() => import("../pages/devices/Documents"));
const AddDocument = lazy(() => import("../pages/devices/wizard/index"));

const Identifiers = lazy(() => import("../pages/devices/Identifiers"));

const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="changecontrol" />
    ),
  },
  {
    path: "devices",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DevicesList />
        </Suspense>
      </ErrorBoundary>
    ),
  },

  {
    path: "devices/adddevices",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DevicesAdd />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/othernames",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <OtherNames />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/editdevices",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DevicesEdit />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/addothername",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddOtherName/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/components",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Components/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/addcomponents",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddComponents/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/models",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Models/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/addmodel",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddModel/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/specifications",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Specifications/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/addspecification",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddSpecifications/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/applicablestandards",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ApplicableStandards/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/identifiers",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Identifiers/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/addapplicablestandard",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddApplicableStandard/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/packages",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Packages/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/addpackage",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddPackage/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/documents",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DocumentsList/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "devices/adddocument",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddDocument/>
        </Suspense>
      </ErrorBoundary>
    ),
  },
  
  {
    path: "changecontrol",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ChangeList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "changecontrol/addchangecontrol",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ChangeAdd />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "changecontrol/editchangecontrol",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ChangeEdit />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "changecontrol/impactassessment",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <ImpactAssessmentList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "changecontrol/addimpactassessment",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <AddImpactAssessment />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "changecontrol/editimpactassessment",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <EditImpactAssessment />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "changecontrol/Documents",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Documents />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "changecontrol/Content",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Content />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "changecontrol/Reports",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <Reports />
        </Suspense>
      </ErrorBoundary>
    ),
  },
];

const Router = createBrowserRouter(routesForm);

export { Router };